var l = Object.defineProperty;
var g = (u, t, a) => t in u ? l(u, t, { enumerable: !0, configurable: !0, writable: !0, value: a }) : u[t] = a;
var h = (u, t, a) => (g(u, typeof t != "symbol" ? t + "" : t, a), a);
import { EditorAPI as c } from "../EditorAPI.js";
import { getSpacePermissionConfig as y } from "../../utils/getSpacePermissionConfig.js";
import { getPermissionAndSubscriptionConfig as r } from "../../utils/getPermissionAndSubscriptionConfig.js";
class P {
  constructor(t) {
    h(this, "api");
    this.api = t;
  }
  async get(t, a, e) {
    const s = await r(t, a, e), i = `/space/${t}`;
    return await new c(this.api).get(i, !0, s);
  }
  async getPublic(t, a) {
    const e = a === "SLUG" ? `/space/public?slug=${t}` : `/space/public?custom_domain=${t}`;
    return await new c(this.api).get(e, !1);
  }
  async list() {
    const t = "/space/list";
    return await new c(this.api).get(t);
  }
  async updateNavbar(t, a, e, s, i, n, p) {
    const o = {
      navbar: a,
      updated_at: e
    };
    return this.update(t, o, s, "navbar", i, n, p);
  }
  async updateSettings(t, a, e, s) {
    const i = {
      name: a.name,
      icon: a.icon,
      slug: a.slug
    };
    return this.update(t, i, !0, "site", e, s);
  }
  async updateMetadata(t, a, e, s) {
    const i = {
      metadata: a
    };
    return this.update(t, i, !0, "metadata", e, s);
  }
  async updateCustomizationPartial(t, a, e, s) {
    const i = await r(t, e, s), n = `/space/customization_partial/${t}?force=true`;
    return await new c(this.api).put(n, a, !0, i);
  }
  async updateRoutes(t, a, e, s) {
    const i = {
      routes: a
    };
    return this.update(t, i, !0, "routes", e, s);
  }
  async create(t) {
    const a = "/space/create?create_type=template";
    return await new c(this.api).post(a, t);
  }
  async createNoPages(t) {
    const a = "/space/create?create_type=empty";
    return await new c(this.api).post(a, t);
  }
  async delete(t, a) {
    const e = `/space/${t}`, s = await y(t, a);
    return await new c(this.api).delete(e, null, !0, s);
  }
  async publish(t, a, e, s, i) {
    const n = await r(t, s, i), p = `/space/publish/${t}?all_public=${e.toString()}`;
    return await new c(this.api).put(p, a, !0, n);
  }
  async publishByPageIDs(t, a, e, s, i, n, p) {
    const o = await r(t, n, p), d = {
      space: a,
      page_ids: e
    };
    let m = `/space/publish_by_page_id/${t}?all_public=${s.toString()}`;
    return i && (m = `${m}&keep_published=${i}`), await new c(this.api).put(m, d, !0, o);
  }
  async updateCustomDomain(t, a, e, s, i) {
    const n = {
      custom_domain: a,
      redirect_custom_domain: e
    };
    return this.update(t, n, !0, "custom_domain", s, i);
  }
  async updateCustomDomainRedirect(t, a, e, s) {
    const i = {
      redirect_custom_domain: a
    }, n = await r(t, e, s), p = `/space/custom_domain/redirect/${t}`;
    return await new c(this.api).put(p, i, !0, n);
  }
  async checkCustomDomain(t, a, e, s) {
    const i = await r(t, e, s), n = `/space/custom_domain/${t}?domain=${a}`;
    return await new c(this.api).get(n, !0, i);
  }
  async getCustomDomainConfig(t, a, e, s) {
    const i = await r(t, e, s), n = `/space/custom_domain/config/${t}?domain=${a}`;
    return await new c(this.api).get(n, !0, i);
  }
  async deleteCustomDomain(t, a, e, s) {
    const i = await r(t, e, s), n = `/space/custom_domain/${t}?domain=${a}`;
    return await new c(this.api).delete(n, null, !0, i);
  }
  async deleteCustomDomainRedirect(t, a, e, s) {
    const i = await r(t, e, s), n = `/space/custom_domain/redirect/${t}?domain=${a}`;
    return await new c(this.api).delete(n, null, !0, i);
  }
  async update(t, a, e, s, i, n, p) {
    const o = await r(t, i, n, p), d = `/space/${s}/${t}?force=${e}`, m = new c(this.api);
    return m.setLogoutCallback(p), await m.put(d, a, !0, o);
  }
}
export {
  P as SpaceAPI
};
